export const DISLIKE = 0;
export const LIKE = 1;
export const HEART = 2;

export const RATING_TRANS = {
    0: 'products.feedback.comment.explain_dislike',
    1: 'products.feedback.comment.explain_like',
    2: 'products.feedback.comment.explain_heart',
};
